export default {
    //ProductList
    your_created_projects: "Els teus cursos creats",
    new_project: "Nou Curs",
    projects_name: "NOM DEL CURS",
    update_at: 'Actualitzat el ',
    coming_soon: 'Properament',
    search_your_project: 'Busca el teu curs...',
    project_name: 'Nom del curs',
    loading_products: 'Carregant productes...',

    //ProductEditComponent
    modify_project: 'Modificant el teu producte',
    general: 'General',
    branding: 'Branding',
    product_page: 'Pàgina de Producte',
    sale: 'Venda',
    seo_text: 'SEO',
    projects: 'Projectes',

    //CategoriesSlideOverComponent
    categories: 'Categories',
    text_category: 'Classifica els teus productes per categories, així facilitaràs als teus alumnes comprar els teus cursos.',
    select_category: 'Selecciona categoria...',
    ebook: 'E-book',
    online_project: 'Curs en línia',
    blended_learning: 'Curs semipresencial',
    online_program: 'Programa Online',
    webinar_consulting: 'Webinar / Consultoria online',
    remove_category: 'Eliminar categoria',
    href_help: 'Vull saber més sobre les categories',

    //ProductEdit
    //CustomCategoriesComponent
    //GeneralComponent
    category: 'Categoria',
    duration: 'Durada',
    featured_product: 'Producte destacat',
    delete_project: 'Esborrar Curs',
    warning_delete: 'Atenció!',
    message_delete_project: 'En eliminar el curs perdràs totes les dades definitivament.',
    question_delete_project: 'Esteu segur que voleu suprimir aquest curs?',
    delete: 'Eliminar',
    confirmation_delete_project: '(*) Aquesta casella és obligatòria per eliminar el curs',
    //PageComponent
    principal_page: 'Pàgina principal',
    objectives_presentation: 'Presentació i objectius',
    learning_objectives: 'No us oblideu de descriure breument els objectius d\'aprenentatge.',
    teaching_staff: 'Metodologia i professorat',
    public: 'Públic',
    content: 'Contingut',
    sidebar: 'Barra Lateral',
    //ProductBrandingComponent
    banner: 'Banner',
    upload_banner: 'Puja el teu banner',
    banner_format: 'PNG, JPG, GIF fins a 3MB',
    promotional_video: 'Vídeo Promocional',
    video_url: 'URL del vídeo',
    video_info: 'Si tens un vídeo promocional, col·loca aquí la url del vídeo a Youtube o Vimeo.',
    //SellComponent
    price_management: 'Gestió de preus',
    sell_price: 'Preu de venda',
    tax: 'A €. (-3% taxes)',
    price_offer: "Preu d'oferta",
    text_configuration: 'Configuració de textos',
    free_text_button: 'Títol de botó de compra gratuït',
    text_if_free: 'Aquest títol apareixerà si el teu producte és gratuït',
    on_sale: 'En venda',
    sale_info: 'Si està activat el teu producte estarà a la venda',

    //SeoComponent
    seo_configuration: 'Configuració SEO',
    seo_title: 'Títol SEO',
    slug: 'Slug',
    seo_description: 'Descripció SEO',

    //ProductListComponent
    featured: 'Destacat',
    classroom: 'Aula',
    slug_text: 'slug',
    product: 'producte',
    products: 'productes',
    preview: 'Previsualitzar',

    //AttachProjectSlideOverComponent
    attach_project: 'Associar Projecte',
    loading_projects: 'Carregant projectes associats...',
    project_selected: 'Projecte seleccionat',
    quest_attach_project: 'Vols adjuntar aquest projecte?',
    back: 'Tornar',
    add_project: 'Adjuntar Projecte',
    close_panel: 'Tancar panell',

    //ProjectAttachedListComponent
    attached_projects: 'Projectes Associats',
    loading_products_attached: 'Carregant productes associats...',
    unattach_project: 'Desassociar projecte',
    info_unattach_project: 'En desasociar el projecte al producte, els alumnes que comprin aquest producte no podran accedir al projecte.',
    quest_unattach_project: 'Segur que vols desasociar el projecte ',

    // ProductList · paginación y estados
    search_label: 'Cercar cursos',
    actions: 'Accions',
    edit_product: 'Editar curs',
    load_error: "No s'han pogut carregar els cursos.",
    retry: 'Torna-ho a provar',
    no_results_title: 'No hi ha cursos que coincideixin amb «{search}»',
    no_results_text: "Prova amb un altre nom o revisa l'ortografia.",
    clear_search: 'Esborrar la cerca',
    empty_title: 'Encara no has creat cap curs',
    empty_text: 'Crea el teu primer curs per començar a vendre’l a la teva acadèmia.',
    product_published: "S'ha publicat el curs",
    product_unpublished: "S'ha despublicat el curs",
    unexpected_error: "S'ha produït un error inesperat",

    // TipTapEditorComponent · menú de bloques (página de producto)
    blocks_menu: 'Blocs',
    blocks_menu_label: 'Insereix un bloc predissenyat',
    block_badge: 'Avís destacat',
    block_key_facts: 'Dades clau',
    block_separator: 'Separador',
    block_price_enroll: 'Preu i inscripció',

    // BlockControls · controles de cada bloque
    block_move_up: 'Puja «{block}»',
    block_move_down: 'Baixa «{block}»',
    block_remove: 'Treu «{block}»',
    block_remove_confirm_title: 'Vols treure aquest bloc?',
    block_remove_confirm_text: 'El bloc desapareixerà del text. Pots recuperar-lo amb Desfés (Ctrl+Z) mentre no desis.',
    block_remove_confirm_action: 'Treu',

    // PriceEnrollNodeView · bloque «Precio e inscripción»
    price_enroll_price: 'Preu o text',
    price_enroll_price_placeholder: 'Ex.: 1.200 € / Bonificat / Gratuït',
    price_enroll_button_text: 'Text del botó',
    price_enroll_button_url: 'Enllaç del botó',
    price_enroll_note: 'Nota (opcional)',
    price_enroll_button_color: 'Color del botó',
    price_enroll_url_invalid: 'Introdueix un enllaç que comenci per https://, http:// o mailto:',
    price_enroll_no_button: 'Sense un enllaç vàlid, el botó no es mostrarà a la pàgina pública.',
    price_enroll_default_button: 'Inscriu-te',

    // InfoPricesNodeView · bloque «Tarifas informativas»
    block_info_prices: 'Tarifes informatives',
    info_prices_title: 'Títol (opcional)',
    info_prices_title_placeholder: 'Ex.: Mòdul d’Inspecció de Treball',
    info_prices_row: 'Fila {n}',
    info_prices_row_label: 'Etiqueta',
    info_prices_row_label_placeholder: 'Ex.: Col·legiats',
    info_prices_row_amount: 'Import',
    info_prices_row_amount_placeholder: 'Ex.: 360 € / Bonificat',
    info_prices_add_row: 'Afegeix una fila',
    info_prices_remove_row: 'Treu la fila {n}',
    info_prices_accent_color: 'Color de la primera fila',
    info_prices_default_row_1: 'Tarifa general',
    info_prices_default_row_2: 'Tarifa reduïda',

    // LinkButtonNodeView · bloque «Botón de enlace»
    block_link_button: 'Botó d\'enllaç',
    link_button_default_text: 'Més informació',
    link_button_text: 'Text del botó',
    link_button_url: 'Enllaç',
    link_button_url_invalid: 'Introdueix un enllaç que comenci per https://, http:// o mailto:',
    link_button_no_link: 'Sense un enllaç vàlid no es mostra el botó. Afegeix un enllaç que comenci per https://, http:// o mailto:',
    link_button_color: 'Color del botó',
    link_button_variant: 'Estil',
    link_button_variant_solid: 'Farciment',
    link_button_variant_outline: 'Contorn',

    // TipTapEditorComponent · barra de herramientas (FE-054)
    editor_toolbar: 'Format del text',
    editor_bold: 'Negreta',
    editor_italic: 'Cursiva',
    editor_underline: 'Subratllat',
    editor_strike: 'Ratllat',
    editor_heading_2: 'Títol 2',
    editor_heading_3: 'Títol 3',
    editor_heading_4: 'Títol 4',
    editor_bullet_list: 'Llista amb pics',
    editor_ordered_list: 'Llista numerada',
    editor_align_left: 'Alinea a l\'esquerra',
    editor_align_center: 'Centra',
    editor_align_right: 'Alinea a la dreta',
    editor_blockquote: 'Cita',
    editor_code_block: 'Bloc de codi',
    editor_link: 'Enllaç',
    editor_remove_link: 'Treu l\'enllaç',
    editor_insert_image: 'Insereix una imatge',
    editor_horizontal_rule: 'Línia horitzontal',
    editor_text_color: 'Color del text',
    editor_remove_color: 'Treu el color',
    editor_undo: 'Desfés',
    editor_redo: 'Refés',
    editor_edit_html: 'Edita l\'HTML',
    editor_insert_badge: 'Insereix un avís destacat',
    editor_insert_icon_list: 'Insereix una llista amb icones',
    editor_insert_raw_html: 'Insereix HTML personalitzat (sense restriccions)',
    editor_badge_panel: 'Avís destacat:',
    editor_badge_border: 'Vora',
    editor_badge_text: 'Text',
    editor_badge_background: 'Fons',
    editor_icon_list_panel: 'Llista amb icones:',
    editor_icon_list_color: 'Color de la icona',
    editor_link_url: 'URL de l\'enllaç:',
    editor_image_url: 'URL de la imatge:',
    editor_apply: 'Aplica',
    editor_cancel: 'Cancel·la',
    editor_html_source: 'Codi HTML',
}
